<div class="row login-row">
  <div class="col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-xl-4 offset-xl-4">
    <div class="card-blueGDPR-container">
      <div class="logo-place" @loginItem>
        <img class="logo" src="./assets/ui/svg/multi-color/sharemedix-logo.svg">
      </div>
      <div class="card-blueGDPR-without-top-bar" @loginItemList @popUpIn>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

